import http from '@/plugins/axios/axios';

export default class LoginService {

    autenticar(usuario) {
        return http.post('/api/login/aut-admin', usuario);
    }

    validarToken(usuario) {
        return http.post('/api/login/validar-token', usuario);
    }
    
}